import React, {
  useRef,
  useEffect,
  useState
} from 'react';
import cn from 'classnames';
import styles from './footer.module.css';
import { getObjectValue, accessibleDiv } from '@utility/utills';
import PickMenu from '@containers/PickMenu';
import { LABEL } from '@veriables';
import { onKeyDown } from '../../../utility/utills';
import { useNavigate } from 'react-router-dom';
import HomeIcon from '@assets/images/newUI/FooterIcons/HomeIcon';
import CartIcon from '@assets/images/newUI/FooterIcons/cartIcon';
import OrderinfoIcon from '@assets/images/newUI/FooterIcons/OrderinfoIcon';
import MenuOrdericon from '@assets/images/newUI/FooterIcons/MenuOrdericon';
import CallServerIcon from '@assets/images/newUI/FooterIcons/CallServerIcon';

const useOutsideAlerter = (ref, cb) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        const svg = document.getElementById('menuImageId');
        const style1 = 'od-unselected-footer-icon-color';
        if (svg) {
          svg.setAttribute('class', `${style1} ${styles.storeImg}`);
        }
        cb();
      }
    };
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        handleClickOutside(event);
      }
    });
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleClickOutside);
    };
  }, [ref]);
};

const FooterModel = ({ id, ...props }) => {
  const [isOpen, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const svg = document.getElementById('menuImageId');
  useOutsideAlerter(wrapperRef, () => { setOpen(false); });
  props.handleMenuPopup(isOpen);
  return (
    <div ref={wrapperRef} role="button" tabIndex={0} onKeyDown={(ev) => { if (ev.key === 'Enter' || ev.key === ' ') { if (svg) svg.setAttribute('class', `od-selected-footer-icon-color ${styles.storeImg}`); setOpen(!isOpen); } }} className={`tab-icon ${isOpen ? 'footerIconColor ' : 'od-unselected-footer-icon-text-color'}`} onClick={() => { if (svg) svg.setAttribute('class', `od-selected-footer-icon-color ${styles.storeImg}`); setOpen(!isOpen); }}>
      {isOpen ? props.children : props.children[0]}
    </div>
  );
};
const RenderMenuItem = ({ menuItem, ...props }) => {
  const {
    navigateTo,
    index,
    popInData,
    closeOnSamePage,
    menusList,
    getCartQuantity,
    onClickCartHandler,
    onPreviewSync,
    setActiveCart
  } = props;
  const path = window.location.pathname;
  const [menuPopup, setMenuPopup] = useState(false);
  const navigate = useNavigate();
  const supportsCallServer = getObjectValue(() => props.popInData.enableRequestAssistance, false);
  const [isActiveServer, setIsActiveServer] = useState(false);
  const onBagClick = () => {
    if (popInData.flowType === 2 || popInData.flowType === 11) {
      navigateTo('/mycheck');
    } else {
      navigate('/orderInfo');
    }
    setActiveCart(false);
  };


  const handleMenuPopup = (status) => {
    setMenuPopup(status);
  };
  const storeMenu = () => {
    window.sessionStorage.setItem('storeMenu', 1);
  };
  useEffect(() => {
    window.sessionStorage.removeItem('storeMenu', true);
  }, [storeMenu]);

  const handleNavForTile = () => {
    if (props?.menusList[props.menuIndex]?.mWebScreenDisplayStyle === 2 || props.menusList[props.menuIndex]?.mWebScreenDisplayStyle === 1) {
      window.sessionStorage.setItem('isTile', true);
    }
  };

  const returnPath = () => {
    const path1 = window.location.pathname.slice(1);
    if (window.location.pathname === '/selected-cart/0' || window.location.pathname === '/upsell') {
      return LABEL().FOOTER_MY_BAG;
    } if (window.sessionStorage.getItem('storeMenu')) {
      return LABEL().FOOTER_MENUS;
    } if (window.location.pathname === '/mycheck') {
      return LABEL().FOOTER_MY_CHECK;
    } if (window.location.pathname === '/home') {
      return LABEL().FS_HOME;
    } if (window.location.pathname === '/orders') {
      return LABEL().FS_ORDERS;
    }
    return path1;
  };

  const getThemeIcons = (imageUrl, imageId, activePath, isFromCart) => {
    return (
      <>
        <svg id={imageId} className={cn(styles.storeImg2, isFromCart && styles.newCartIconStyle, activePath ? 'od-bottomNav-selectedIconFill-color' : 'od-bottomNav-unselectedIconFill-color', getObjectValue(() => props.themeProperties.appMyCheckButtonImageUrl, false) && styles.storeImg3)}>
          <image href={imageUrl} width="24" height="25" alt="store" />
        </svg>
        {getCartQuantity() > 0 && isFromCart && (
        <span
          className={cn(
            styles.cartQuantity,
            getCartQuantity() > 9 ? styles.right8 : '',
            `${styles.supportdisplayCartQty} ${styles.iconPosition} fs-12 fw-700 od-bg-stroke od-headerIcons-bubbleText od-headerIcons-bubbleFill`, getObjectValue(() => props.themeProperties.appCartButtonImageUrl, false) && styles.iconPosition2
          )}
        >
          {getCartQuantity()}
        </span>
        )}
      </>
    );
  };
  const handleCallServer = () => {
    setIsActiveServer(true);
    let dataToSend = {};
    if (props.popInData.checkHeaders && props.popInData.checkHeaders.length > 0 && props.popInData.checkHeaders[0].tab) {
      dataToSend = {
        storeId: props.popInData.store.id,
        sensorName: props.popInData.sensorName ? props.popInData.sensorName : null,
        message: `Guest requires assistance with ${returnPath()}`
      };
    } else {
      dataToSend = {
        storeId: props.popInData.store.id,
        stationId: props.popInData.stationId ? props.popInData.stationId : null,
        message: `Guest requires assistance with ${returnPath()}`
      };
    }
    props.callServer(dataToSend).then(() => {
      window.sessionStorage.getItem('storeMenu');
      props.setNotification({
        type: 'success',
        message: dataToSend.message,
      });
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
    window.sessionStorage.removeItem('storeMenu');
  };
  switch (menuItem.type) {
    case 1:
      return (
        <div key={index} className={`${menuItem.activeLinks.includes(path) ? 'od-bottomNav-IconBackground mt-1' : 'od-unselected-footer-icon-text-color'}`} role="presentation" onClick={() => { navigateTo(menuItem.controlUrl, menuItem.type); setActiveCart(false); }}>
          {getObjectValue(() => props.themeProperties.appHomeButtonImageUrl, false) ? getThemeIcons(props.themeProperties.appHomeButtonImageUrl, 'homeImageId', menuItem.activeLinks.includes(path)) : (<HomeIcon active={cn(styles.cartIconStyle, menuItem.activeLinks.includes(path) && 'od-bottomNav-unselectedIconFill footerIconColor defaultDisplayIconColor')} />)}
          <div className="fs-12 fw-600 text-color od-bottomNav-IconText">{props.popInData.flowType === 2 ? LABEL().FS_MY_CHECK : LABEL().FS_ORDER_INFO}</div>
        </div>
      );
    case 4:
      return (
        <>
          <div key={index} className={`${menuItem.activeLinks.filter(() => path.includes('/mycheck')).length > 0 ? '' : 'od-unselected-footer-icon-text-color'} tab-icon`} role="presentation" onClick={() => { onBagClick(); }}>
            <div className={cn(`${menuItem.activeLinks.filter(() => path.includes('/mycheck')).length > 0 ? 'od-bottomNav-IconBackground footerIconColor mt-1 ' : 'od-unselected-footer-icon-text-color tab-icon'}`, 'iconFooterStyle')}>
              {getObjectValue(() => props.themeProperties.appMyCheckButtonImageUrl, false) ? getThemeIcons(props.themeProperties.appMyCheckButtonImageUrl, 'appMyCheckImageId', menuItem.activeLinks.filter(() => path.includes('/mycheck')).length > 0) : (<OrderinfoIcon active={cn(styles.orderInfoIconStyle, menuItem.activeLinks.filter(() => path.includes('/mycheck')).length > 0 ? 'od-bottomNav-selectedIconFill' : 'od-bottomNav-unselectedIconFill footerIconColor defaultDisplayIconColor')} />)}
            </div>
            <div className="fs-12 fw-600 text-color od-bottomNav-IconText">{props.popInData.flowType === 2 ? LABEL().FS_MY_CHECK : LABEL().FS_ORDER_INFO}</div>
          </div>
          {supportsCallServer
                && (
                  <div className="tab-icon" role="presentation" onClick={() => { handleCallServer(); }}>
                    <div className={`${cn(isActiveServer && 'od-unselected-footer-icon-text-color')}`}>
                      {getObjectValue(() => props.themeProperties.appCallServerButtonImageUrl, isActiveServer) ? getThemeIcons(props.themeProperties.appCallServerButtonImageUrl, 'cartImageId', isActiveServer) : (<CallServerIcon active={cn(styles.orderInfoIconStyle, 'od-bottomNav-unselectedIconFill defaultDisplayIconColor')} />)}
                    </div>
                    <div className={cn('fs-12 fw-600 text-color mt-0 od-bottomNav-IconText', styles.callServerCust)}>{LABEL().FS_CALL_SERVER}</div>
                  </div>
                )}
          <div key={index} className="od-unselected-footer-icon-text-color tab-icon" role="presentation" onClick={() => { onClickCartHandler(); }}>
            {getObjectValue(() => props.themeProperties.appCartButtonImageUrl, false) ? getThemeIcons(props.themeProperties.appCartButtonImageUrl, 'cartImageId', menuItem.activeLinks.filter(d => path.includes(d)).length > 0, true)
              : (
                <div key={index} className="tab-icon" role="presentation">
                  <div className={cn(styles.newCartIconStyle, 'iconFooterStyle')}>
                    <CartIcon
                      active={cn(styles.cartIconStyle2, menuItem.activeLinks.filter(d => path.includes(d)).length > 0 ? 'od-bottomNav-selectedIconFill-color' : 'od-bottomNav-unselectedIconFill defaultDisplayIconColor')}
                    />
                    {getCartQuantity() > 0 && (
                    <span
                      className={cn(
                        styles.cartQuantity,
                        getCartQuantity() > 9 ? styles.right8 : '',
                        `${styles.supportdisplayCartQty} ${styles.mobCartBubble} fs-12 fw-700 od-bg-stroke od-headerIcons-bubbleText od-headerIcons-bubbleFill`
                      )}
                    >
                      {getCartQuantity()}
                    </span>
                    )}
                  </div>
                </div>
              )}
            <div className="fs-12 fw-600 text-color od-bottomNav-IconText">{LABEL().FS_CART}</div>
          </div>
        </>
      );
    case 5:
      return <div key={index} className={`${menuItem.activeLinks.includes(path) ? 'footerIconColor od-bottomNav-IconBackground' : 'od-unselected-footer-icon-text-color'} tab-icon`} role="presentation" onClick={() => navigateTo(menuItem.controlUrl)}><i className="fas fa-money-check-alt fa-lg" /><div className="">Tab Name</div></div>;
    case 6:
      return (
        <div key={index} className={`tab-icon ${menuItem.activeLinks.includes(path) ? '' : 'od-unselected-footer-icon-text-color'}`} role="presentation" onClick={() => { navigateTo(menuItem.controlUrl, menuItem.type); handleNavForTile(); }}>
          <div className={cn(`${menuItem.activeLinks.includes(path) ? `od-bottomNav-IconBackground footerIconColor ${styles.marginTop4}` : 'od-unselected-footer-icon-text-color tab-icon'}`, 'iconFooterStyle')}>
            {getObjectValue(() => props.themeProperties.appOrdersButtonImageUrl, false) ? getThemeIcons(props.themeProperties.appOrdersButtonImageUrl, 'orderImageId', menuItem.activeLinks.includes(path)) : (<MenuOrdericon active={cn(styles.orderIconStyle, 'defaultDisplayIconColor', menuItem.activeLinks.includes(path) ? 'od-bottomNav-selectedIconFill' : 'od-bottomNav-unselectedIconFill')} />)}
          </div>
          <div className="fs-12 fw-600 text-color od-bottomNav-IconText">{LABEL().FS_ORDERS}</div>
        </div>
      );
    case 8:
      return <div key={index} className={`${menuItem.activeLinks.includes(path) ? 'text-primary od-text-primary' : 'od-tab-icon'} tab-icon`} role="presentation" onClick={() => navigateTo(menuItem.controlUrl)}><i className="fas fa-thumbtack fa-lg" aria-hidden="true" /><div className="">Tab Name</div></div>;
    case 9:
      return <div key={index} className={`${menuItem.activeLinks.includes(path) ? 'text-primary od-text-primary' : 'od-tab-icon'} tab-icon`} role="presentation" onClick={() => navigateTo(menuItem.controlUrl)}><i className="fas fa-map-marker fa-lg" aria-hidden="true" /><div className="">Check In</div></div>;
    case 10:
      return <div key={index} className={`${menuItem.activeLinks.includes(path) ? 'text-primary od-text-primary' : 'od-tab-icon'} tab-icon`} role="presentation" onClick={() => navigateTo(menuItem.controlUrl)}><i className="fas fa-user-clock fa-lg" aria-hidden="true" /><div className="">Tab Name</div></div>;
    case 11:
      return <div key={index} className={`${menuItem.activeLinks.includes(path) ? 'text-primary od-text-primary' : 'od-tab-icon'} tab-icon`} role="presentation" onClick={() => navigateTo(menuItem.controlUrl)}><i className="far fa-user fa-lg" aria-hidden="true" /><div className="">Tab Name</div></div>;
    case 12:
      return (
        menusList.length > 1
          ? (
            <FooterModel id="menuImageId" role="button" tabIndex={0} onKeyDown={ev => onKeyDown(ev, handleMenuPopup, !menuPopup)} handleMenuPopup={handleMenuPopup}>
              <div className="ignoreDivs" role="presentation" key={12} onClick={() => { storeMenu(); }}>
                {getObjectValue(() => props.themeProperties.appMenusButtonImageUrl, false) ? getThemeIcons(props.themeProperties.appMenusButtonImageUrl, 'menuImageId', menuPopup) : (<i className="fa fa-book fa-lg" aria-hidden="true" />)}
                <div className="ignoreDivs" role="presentation" onClick={() => { props.handleSessionTrack(); }}>
                  {LABEL().FOOTER_MENUS}
                </div>
              </div>
              <div className={styles.footerPopUp}>
                <PickMenu navigateTo={navigateTo} />
              </div>
            </FooterModel>
          ) : null
      );
    case 13:
      return <div key={index} className={`${menuItem.activeLinks.includes(path) ? 'text-primary od-text-primary' : 'od-tab-icon'} tab-icon`} role="presentation" onClick={() => navigateTo(window.sessionStorage.getItem('accountPageToRedirect'))}><i className="fas fa-chevron-right" /><div className="">Tab Name</div></div>;
    case 14: // closeOnSamePage
      return <div key={index} className={`${menuItem.activeLinks.includes(path) ? 'text-primary od-text-primary' : 'od-tab-icon'} tab-icon`} role="presentation" onClick={() => closeOnSamePage()}><i className="fas fa-chevron-left fa-lg" /></div>;
    case 15:
      return (
        <div key={index} className="tab-icon" role="presentation" onClick={() => { onClickCartHandler(); }}>
          <div className={cn(styles.newCartIconStyle, window.location.pathname === ('/upsell') ? 'footerIconColor' : '', 'iconFooterStyle')}>
            <CartIcon active={cn(styles.cartIconStyle, 'od-bottomNav-unselectedIconFill defaultDisplayIconColor')} />
            {getCartQuantity() > 0 && (
            <span className={cn(styles.cartQuantity, getCartQuantity() > 9 ? styles.right8 : '', getCartQuantity() > 0 ? 'od-cart-button badge badge-success text-white' : '')}>
              {getCartQuantity()}
            </span>
            )}
          </div>
        </div>
      );

    case 16:
      return ((popInData.flowType === 2 || popInData.flowType === 3 || popInData.flowType === 4 || popInData.flowType === 5 || popInData.flowType === 16) || (popInData.checkHeaderId && popInData.checkHeaderId !== 0)) ? (
        <div
          key={16}
          className={`tab-icon ${menuItem.activeLinks.includes(path) ? '' : 'od-unselected-footer-icon-text-color '}`}
          role="presentation"
          onClick={() => {
            navigateTo(menuItem.controlUrl, menuItem.type);
            handleMenuPopup(false);
          }}
        >
          {getObjectValue(() => props.themeProperties.appHomeButtonImageUrl, false)
            ? getThemeIcons(props.themeProperties.appHomeButtonImageUrl, 'homeImageId', menuItem.activeLinks.includes(path))
            : (
              <div className={cn(`${menuItem.activeLinks.includes(path) ? `footerIconColor od-bottomNav-IconBackground ${styles.marginTop4}` : 'tab-icon'}`, 'iconFooterStyle')}>
                {/* <img src={homeFooterIcon} alt="homeIcon" className={styles.cartIconStyle} /> */}
                <HomeIcon active={cn(styles.cartIconStyle, menuItem.activeLinks.includes(path) ? 'od-bottomNav-selectedIconFill' : 'od-bottomNav-unselectedIconFill', 'defaultDisplayIconColor')} />
              </div>
            )}
          <div className="fs-12 fw-600 text-color od-bottomNav-IconText">
            {LABEL().FS_HOME}
          </div>
        </div>

      ) : null;
    case 17:
      return (window.localStorage.getItem('isPreviewMode')) && (
        // <div className="d-none" />
        <div key={index} className={`${menuItem.activeLinks.includes(path) ? 'footerIconColor od-bottomNav-IconBackground' : 'od-unselected-footer-icon-text-color tab-icon'}`} role="presentation" onClick={() => onPreviewSync()}><i className="fas fa-sync-alt" aria-hidden="true" /><div className="">Sync</div></div>
      );
    default:
      return undefined;
  }
};

const Footer = (props) => {
  const validate = (footerItem) => {
    if (footerItem.type === 1 && getObjectValue(() => props.popInData.actions.length, 0) === 0) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    accessibleDiv('footer-menu');
  }, [props.menuItems]);

  return (
    <>
      {window.innerWidth > 1023 || window.location.pathname.includes('/receipt') ? '' : (
        <div className={cn(styles.footerFixed, styles.footerList, 'od-bottomNav-backgroundFill')} id="footer-menu">
          <div className={cn('container', styles.desktopFooterContainer)}>
            <div className="row">
              <div className={cn('d-flex justify-content-between align-items-center w-100 p-0 m-0 pl-2 pr-2', styles.desktopFooterItems)}>
                {props.menuItems.map(menuItem => validate(menuItem) && (menuItem.type !== null) && (menuItem.type !== 12) && <RenderMenuItem menuItem={menuItem} {...props} />)}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Footer;
